/**
 * BreadcrumbOptions
 * @enum Title for a breadcrumb
 */
enum BreadcrumbOptions {
  /** Dashboard title */
  Dashboard = 'Dashboard',
  /** Clients */
  Clients = 'All Clients'
}

export default BreadcrumbOptions;
